import { anamService } from './anam';
import { tavusService } from './tavus';
import type { AvatarProvider, AvatarSessionResponse } from '../types/api.types';

// Stable adapters allow mounted video panels to follow the selected provider.
const adapters = {
  anam: {
    selectAvatarForCase: () => anamService.selectAvatarForCase(),
    initializeAvatar: (session: AvatarSessionResponse, avatarId: string, callbacks: Parameters<typeof anamService.initializeAvatar>[2]) => {
      if (session.provider !== 'anam') throw new Error('Unexpected avatar provider');
      return anamService.initializeAvatar(session, avatarId, callbacks);
    },
    disconnect: () => anamService.disconnect(),
    speak: (text: string, context: Parameters<typeof anamService.speak>[1]) => anamService.speak(text, context),
    interrupt: () => anamService.interrupt(),
    canInterrupt: () => anamService.canInterrupt(),
    attachToElement: (element: HTMLVideoElement) => anamService.attachToElement(element),
    detachFromElement: (element: HTMLVideoElement) => anamService.detachFromElement(element),
    isPlaybackBlocked: () => anamService.isPlaybackBlocked(),
    resumePlayback: () => anamService.resumePlayback(),
  },
  tavus: {
    selectAvatarForCase: () => tavusService.selectAvatarForCase(),
    initializeAvatar: (session: AvatarSessionResponse, avatarId: string, callbacks: Parameters<typeof anamService.initializeAvatar>[2]) => {
      if (session.provider !== 'tavus') throw new Error('Unexpected avatar provider');
      return tavusService.initializeAvatar(session, avatarId, callbacks);
    },
    disconnect: () => tavusService.disconnect(),
    speak: (text: string, context: Parameters<typeof anamService.speak>[1]) => tavusService.speak(text, context),
    interrupt: () => tavusService.interrupt(),
    canInterrupt: () => tavusService.canInterrupt(),
    attachToElement: (element: HTMLVideoElement) => tavusService.attachToElement(element),
    detachFromElement: (element: HTMLVideoElement) => tavusService.detachFromElement(element),
    isPlaybackBlocked: () => tavusService.isPlaybackBlocked(),
    resumePlayback: () => tavusService.resumePlayback(),
  },
};
export const getAvatarService = (provider: AvatarProvider = 'anam') => adapters[provider];
